import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ComponentPositionModelList from './ComponentPositionModelList';
import { getComponentPositionsModel, getUserProfileWidget, getUserOrgModelCategoryType, getModelCategoryComponentPositions } from '../../selectors/index';
import {
  getComponentPositionsThunk,
  deleteComponentPositionThunk,
  saveComponentPositionThunk,
  setComponentPositionChangeThunk,
  setComponentPositionShowScreenStatusThunk,
  uploadComponentToS3UpdateShadowThunk,
  setCurrentPage,
  setPageFilter,
  setComponentPositionsFilteredDataThunk
} from '../../actions/model';

const mapStateToProps = state => {
  return {
    modelCategoryComponentPositions: getModelCategoryComponentPositions(state),
    userProfileWidgets: getUserProfileWidget(state),
    ComponentPositionsManager: getComponentPositionsModel(state),
    userModelCategories: getUserOrgModelCategoryType(state)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getComponentPositions: (modelCategoryId, modelId) => getComponentPositionsThunk(modelId, null, null, 'MODELCOMPONENTPOSITIONLIST', modelCategoryId),
      saveComponentPosition: componentPositionDetails =>
        saveComponentPositionThunk(componentPositionDetails, 'MODEL_COMPONENT_POSTSITON_ADD'),
      deleteComponentPosition: componentPositionDetails =>
        deleteComponentPositionThunk(componentPositionDetails, 'MODEL_COMPONENT_POSTSITON_DELETE'),
      setComponentPositionChange: componentPositionDetails => setComponentPositionChangeThunk(componentPositionDetails),
      setComponentPositionShowScreenStatus: status => setComponentPositionShowScreenStatusThunk(status),
      uploadComponentToS3UpdateShadow: (modelCategoryId, modelId) => uploadComponentToS3UpdateShadowThunk(modelCategoryId, modelId, 'MODEL_COMPONENT_POSTSITON_UPLOAD_FILE'),
      setCurrentPage: currentPage => setCurrentPage(currentPage),
      setPageFilter: filter => setPageFilter(filter),
      setFilterData: filteredData => setComponentPositionsFilteredDataThunk(filteredData)

    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ComponentPositionModelList);



